// extracted by mini-css-extract-plugin
export var checkbox = "_6d-0";
export var circle = "_6d-3";
export var horizontalContainer = "_6d-7";
export var sm = "_6d-5";
export var switch0 = "_6d-2";
export var switchDisabled = "_6d-8";
export var switchEnabled = "_6d-1";
export var textSwitchContainer = "_6d-9";
export var textSwitchOption = "_6d-a";
export var textSwitchOptionSelected = "_6d-b";
export var verticalContainer = "_6d-6";
export var xs = "_6d-4";